import React  from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const PasswordField = ({
  input = {},
  meta = {},
  className = null,
  errorMessage = null,
  placeholder = null
}) => {
  const { touched, error, submitFailed } = meta;

  const showError = error && submitFailed && touched;

  const passwordFieldClassNames = classNames('PasswordField', className);

  return (
    <div className={passwordFieldClassNames}>
      <div className="passwordInput">
        <input
          {...input}
          type="password"
          placeholder={placeholder}
        />
      </div>

      {
        showError && (
          <p className="error">
            {errorMessage || error}
          </p>
        )
      }
    </div>
  );
};

PasswordField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string
};

export default PasswordField;
